"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A {@link FontStyleDefinition} with all fields nulled.
 * Used to implement custom value support in Theme Editor.
 */
class NullStyle {
    constructor() {
        this.name = null;
        this.style = null;
        this.weight = null;
    }
}
exports.default = NullStyle;
//# sourceMappingURL=NullStyle.js.map